import { z } from 'zod';
import { transformAndFilterValidEdges } from '../../../common/tools/transformEdgesUtils';

// Simplified asset for resource library item queries
export const AssetBaseSchema = z
    .object({
        fullpath: z.string(),
        mimetype: z.string(),
        type: z.enum(['document', 'image', 'video', 'text', 'archive', 'audio']),
    })
    .describe('AssetBaseSchema');

// Full asset schema with ID
export const AssetSchema = AssetBaseSchema.merge(
    z.object({
        id: z.string(),
    })
);

export const GetAssetListingSchema = z
    .object({
        getAssetListing: z.object({
            edges: z
                .array(
                    z.object({
                        node: z.unknown(),
                    })
                )
                .transform((edges) => transformAndFilterValidEdges(AssetSchema, edges)),
        }),
    })
    .describe('GetAssetListingSchema');
